/**
 * Cliente de la API de Leiten.
 *
 * Todas las funciones LANZAN (throw) un ApiError si la request falla, en lugar de
 * devolver el string 'error'. Devolver un string hacía que el error terminara
 * guardado en el estado como si fuera data, y después reventaba en el primer
 * .map() / .find(). Quien llama decide qué hacer con el error.
 *
 * La URL base y el token salen de .env (ahí están comentadas las alternativas
 * de localhost).
 */

const BASE_URL = process.env.REACT_APP_LEITEN_URL;
const ACCESS_TOKEN = process.env.REACT_APP_LEITEN_ACCESS;

export class ApiError extends Error {
    constructor(message, { status, url } = {}) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.url = url;
    }
}

async function request(path, { method = 'GET', auth = false, body } = {}) {
    const url = `${BASE_URL}${path}`;
    const headers = {};

    if (auth) {
        headers['Content-Type'] = 'application/json';
        headers['Authorization'] = ACCESS_TOKEN;
    } else if (body) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(url, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
        throw new ApiError(`${method} ${path} respondió ${response.status}`, {
            status: response.status,
            url,
        });
    }

    return response.json();
}

export function getBrands() {
    return request('/api/leiten/marcas', { auth: true });
}

export function getProductsByBrand(slugbrand) {
    return request(`/api/leiten/marcas/${slugbrand}/productos`, { auth: true });
}

export function getProductById(id) {
    return request(`/api/product/${id}`);
}

// TODO: sin uso hoy. Se deja porque documenta el endpoint de búsqueda por código.
export function getProductByCode(code) {
    return request(`/api/leiten/productos/codigo/${code}`, { auth: true });
}

export function getKitMaintenance() {
    return request('/api/leiten/kit-mantenimiento', { auth: true });
}

export function getProductSearch() {
    return request('/api/product-search');
}

// TODO: sin uso hoy. Se deja porque documenta el endpoint de precios.
export function getProductPrice(id) {
    return request(`/api/leiten/precios-producto/${id}`, { method: 'POST', auth: true });
}

export function postSendEmail(data) {
    return request('/api/leiten/postventa-contacto', {
        method: 'POST',
        auth: true,
        body: data,
    });
}
